// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.sound-editor_editor-container_u4gVN {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: calc(2 * 0.5rem);
}

.sound-editor_row_etYpe {
    display: flex;
    flex-direction: row;
    align-items: center;
}

[dir="rtl"] .sound-editor_row-reverse_gT1kt {
    flex-direction: row-reverse;
}

.sound-editor_row_etYpe + .sound-editor_row_etYpe {
    margin-top: calc(2 * 0.5rem);
}

.sound-editor_input-group_CbHjS {
    display: flex;
    flex-direction: row;
}

[dir="ltr"] .sound-editor_input-group_CbHjS + .sound-editor_input-group_CbHjS {
    margin-left: calc(2 * 0.5rem);
}

[dir="rtl"] .sound-editor_input-group_CbHjS + .sound-editor_input-group_CbHjS {
    margin-right: calc(2 * 0.5rem);
}

[dir="ltr"] .sound-editor_input-group_CbHjS {
    padding-right: calc(2 * 0.5rem);
    border-right: 1px dashed var(--ui-black-transparent);
}

[dir="rtl"] .sound-editor_input-group_CbHjS {
    padding-left: calc(2 * 0.5rem);
    border-left: 1px dashed var(--ui-black-transparent);
}

[dir="rtl"] .sound-editor_row-reverse_gT1kt > .sound-editor_input-group_CbHjS {
    padding-left: 0;
    padding-right: calc(2 * 0.5rem);
    border-left: none;
    border-right: 1px dashed var(--ui-black-transparent);
}

.sound-editor_name-input_SnE1i {
    width: 100%;
}

.sound-editor_waveform-container_Q15Oq {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;

    position: relative;

    background: hsla(300, 53%, 60%, 0.15);
    border: 1px solid var(--ui-black-transparent);
    border-radius: 5px;

    margin-top: 20px;
    margin-bottom: 20px;
}

.sound-editor_button_JdvOv {
    height: 2rem;
    padding: 0.35rem;
    outline: none;
    background: var(--ui-white);
    border-radius: 0.25rem;
    border: 1px solid var(--ui-black-transparent);
    cursor: pointer;
    font-size: 0.85rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    margin: 0px;
    position: relative;
}

.sound-editor_button_JdvOv:active {
    background: var(--looks-transparent);
}

.sound-editor_button_JdvOv:focus::before {
    content: "";
    position: absolute;
    top: -1px;
    right: -1px;
    bottom: -1px;
    left: -1px;
    border: 1px solid var(--looks-secondary);
    z-index: 1;
}

.sound-editor_button_JdvOv > img {
    flex-grow: 1;
    max-width: 100%;
    max-height: 100%;
    min-width: 1.25rem;
}

.sound-editor_round-button-outer_J4Uag {
    display: flex;
    align-items: center;
    height: 100%;
}

.sound-editor_round-button_Z7v_a {
    height: 3rem;
    width: 3rem;
    outline: none;
    background: var(--looks-secondary);
    border-radius: 100%;
    border: none;
    cursor: pointer;
    padding: 0.75rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.sound-editor_round-button_Z7v_a > img {
    flex-grow: 1;
    max-width: 100%;
    max-height: 100%;
    /*min-width: 1.5rem;*/
}

[dir="rtl"] .sound-editor_undo-icon_qzwjn, [dir="rtl"] .sound-editor_redo-icon_yNaBF {
    transform: scaleX(-1);
}

.sound-editor_trim-button_cBeZK {
    display: flex;
    align-items: center;
    color: var(--text-primary);
    font-size: 0.625rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;

}

[dir="ltr"] .sound-editor_trim-button_cBeZK {
    margin-left: 1rem;
}

[dir="rtl"] .sound-editor_trim-button_cBeZK {
    margin-right: 1rem;
}

.sound-editor_trim-button_cBeZK > img {
    width: 1.25rem;
}

.sound-editor_effects_XD2c5 {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.sound-editor_effect-button_NchAD {
    flex-basis: 60px;
    color: var(--text-primary);
    font-size: 0.625rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    padding: 0.25rem 0;
}

.sound-editor_effect-button_NchAD + .sound-editor_effect-button_NchAD {
    margin: 0;
}

.sound-editor_effect-button_NchAD img {
    width: 1.25rem;
    height: 1.25rem;
    margin-bottom: -0.375rem;
}

.sound-editor_tool-button_Skubj {
    flex-basis: 60px;
    color: var(--text-primary);
    font-size: 0.625rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    padding: 0.25rem 0;
}

.sound-editor_tool-button_Skubj + .sound-editor_tool-button_Skubj {
    margin: 0;
}

.sound-editor_tool-button_Skubj img {
    width: 4rem;
    height: 1.5rem;
    margin-bottom: -0.375rem;
}

[dir="rtl"] .sound-editor_flip-in-rtl_WMq6B img {
    transform: scaleX(-1);
}

[dir="ltr"] .sound-editor_button-group_VRpfa {
    margin-left: 1rem;
}

[dir="rtl"] .sound-editor_button-group_VRpfa {
    margin-right: 1rem;
}

.sound-editor_button-group_VRpfa {
    display: flex;
}

.sound-editor_button-group_VRpfa .sound-editor_button_JdvOv {
    border-radius: 0;
}

.sound-editor_button_JdvOv:not(:last-child) {
    border-right: none;
}

[dir="rtl"] .sound-editor_button_JdvOv:not(:last-child) {
    border-left: none;
    border-right: 1px solid var(--ui-black-transparent);
}

.sound-editor_button-group_VRpfa .sound-editor_button_JdvOv:first-child,
[dir="rtl"] .sound-editor_button-group_VRpfa .sound-editor_button_JdvOv:last-child,
.sound-editor_button-group_VRpfa .sound-editor_button_JdvOv:first-child:focus::before,
[dir="rtl"] .sound-editor_button-group_VRpfa .sound-editor_button_JdvOv:last-child:focus::before {
    border-radius: calc(0.5rem / 2) 0 0 calc(0.5rem / 2);
}

.sound-editor_button-group_VRpfa .sound-editor_button_JdvOv:last-child,
[dir="rtl"] .sound-editor_button-group_VRpfa .sound-editor_button_JdvOv:first-child,
.sound-editor_button-group_VRpfa .sound-editor_button_JdvOv:last-child:focus::before,
[dir="rtl"] .sound-editor_button-group_VRpfa .sound-editor_button_JdvOv:first-child:focus::before {
    border-radius: 0 calc(0.5rem / 2) calc(0.5rem / 2) 0;
}

.sound-editor_button_JdvOv:disabled > img {
    opacity: 0.25;
}

.sound-editor_info-row_rkZGZ {
    display: flex;
    justify-content: space-between;
    margin-top: calc(2 * 0.5rem);
}

.sound-editor_duration_nrOCf {
    font-weight: bold;
}

.sound-editor_advanced-info_neXoT {

}

.sound-editor_alert_XHz2j {
    margin-top: calc(2 * 0.5rem);
    border-radius: 5px;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    border-width: 1px;
    border-style: solid;
}

.sound-editor_stereo_UyJne {
    background-color: rgba(145, 145, 255, 0.3);
    border-color: rgb(145, 145, 255)
}

.sound-editor_too-large_wNGOY {
    background-color: rgba(255, 119, 0, 0.3);
    border-color: rgb(255, 119, 0);
}
`, "",{"version":3,"sources":["webpack://./src/components/sound-editor/sound-editor.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,oDAAoD;AACxD;;AAEA;IACI,8BAA8B;IAC9B,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,oDAAoD;AACxD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;;IAEX,kBAAkB;;IAElB,qCAAqC;IACrC,6CAA6C;IAC7C,kBAAkB;;IAElB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,2BAA2B;IAC3B,sBAAsB;IACtB,6CAA6C;IAC7C,eAAe;IACf,kBAAkB;IAClB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,wCAAwC;IACxC,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;;AAE7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mDAAmD;AACvD;;AAEA;;;;IAII,oDAAoD;AACxD;;AAEA;;;;IAII,oDAAoD;AACxD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;AAEA;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C;AACJ;;AAEA;IACI,wCAAwC;IACxC,8BAA8B;AAClC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.editor-container {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    padding: calc(2 * 0.5rem);\n}\n\n.row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n[dir=\"rtl\"] .row-reverse {\n    flex-direction: row-reverse;\n}\n\n.row + .row {\n    margin-top: calc(2 * 0.5rem);\n}\n\n.input-group {\n    display: flex;\n    flex-direction: row;\n}\n\n[dir=\"ltr\"] .input-group + .input-group {\n    margin-left: calc(2 * 0.5rem);\n}\n\n[dir=\"rtl\"] .input-group + .input-group {\n    margin-right: calc(2 * 0.5rem);\n}\n\n[dir=\"ltr\"] .input-group {\n    padding-right: calc(2 * 0.5rem);\n    border-right: 1px dashed var(--ui-black-transparent);\n}\n\n[dir=\"rtl\"] .input-group {\n    padding-left: calc(2 * 0.5rem);\n    border-left: 1px dashed var(--ui-black-transparent);\n}\n\n[dir=\"rtl\"] .row-reverse > .input-group {\n    padding-left: 0;\n    padding-right: calc(2 * 0.5rem);\n    border-left: none;\n    border-right: 1px dashed var(--ui-black-transparent);\n}\n\n.name-input {\n    width: 100%;\n}\n\n.waveform-container {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    width: 100%;\n\n    position: relative;\n\n    background: hsla(300, 53%, 60%, 0.15);\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 5px;\n\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.button {\n    height: 2rem;\n    padding: 0.35rem;\n    outline: none;\n    background: var(--ui-white);\n    border-radius: 0.25rem;\n    border: 1px solid var(--ui-black-transparent);\n    cursor: pointer;\n    font-size: 0.85rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    margin: 0px;\n    position: relative;\n}\n\n.button:active {\n    background: var(--looks-transparent);\n}\n\n.button:focus::before {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    right: -1px;\n    bottom: -1px;\n    left: -1px;\n    border: 1px solid var(--looks-secondary);\n    z-index: 1;\n}\n\n.button > img {\n    flex-grow: 1;\n    max-width: 100%;\n    max-height: 100%;\n    min-width: 1.25rem;\n}\n\n.round-button-outer {\n    display: flex;\n    align-items: center;\n    height: 100%;\n}\n\n.round-button {\n    height: 3rem;\n    width: 3rem;\n    outline: none;\n    background: var(--looks-secondary);\n    border-radius: 100%;\n    border: none;\n    cursor: pointer;\n    padding: 0.75rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.round-button > img {\n    flex-grow: 1;\n    max-width: 100%;\n    max-height: 100%;\n    /*min-width: 1.5rem;*/\n}\n\n[dir=\"rtl\"] .undo-icon, [dir=\"rtl\"] .redo-icon {\n    transform: scaleX(-1);\n}\n\n.trim-button {\n    display: flex;\n    align-items: center;\n    color: var(--text-primary);\n    font-size: 0.625rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n\n}\n\n[dir=\"ltr\"] .trim-button {\n    margin-left: 1rem;\n}\n\n[dir=\"rtl\"] .trim-button {\n    margin-right: 1rem;\n}\n\n.trim-button > img {\n    width: 1.25rem;\n}\n\n.effects {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n}\n\n.effect-button {\n    flex-basis: 60px;\n    color: var(--text-primary);\n    font-size: 0.625rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    padding: 0.25rem 0;\n}\n\n.effect-button + .effect-button {\n    margin: 0;\n}\n\n.effect-button img {\n    width: 1.25rem;\n    height: 1.25rem;\n    margin-bottom: -0.375rem;\n}\n\n.tool-button {\n    flex-basis: 60px;\n    color: var(--text-primary);\n    font-size: 0.625rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    padding: 0.25rem 0;\n}\n\n.tool-button + .tool-button {\n    margin: 0;\n}\n\n.tool-button img {\n    width: 4rem;\n    height: 1.5rem;\n    margin-bottom: -0.375rem;\n}\n\n[dir=\"rtl\"] .flip-in-rtl img {\n    transform: scaleX(-1);\n}\n\n[dir=\"ltr\"] .button-group {\n    margin-left: 1rem;\n}\n\n[dir=\"rtl\"] .button-group {\n    margin-right: 1rem;\n}\n\n.button-group {\n    display: flex;\n}\n\n.button-group .button {\n    border-radius: 0;\n}\n\n.button:not(:last-child) {\n    border-right: none;\n}\n\n[dir=\"rtl\"] .button:not(:last-child) {\n    border-left: none;\n    border-right: 1px solid var(--ui-black-transparent);\n}\n\n.button-group .button:first-child,\n[dir=\"rtl\"] .button-group .button:last-child,\n.button-group .button:first-child:focus::before,\n[dir=\"rtl\"] .button-group .button:last-child:focus::before {\n    border-radius: calc(0.5rem / 2) 0 0 calc(0.5rem / 2);\n}\n\n.button-group .button:last-child,\n[dir=\"rtl\"] .button-group .button:first-child,\n.button-group .button:last-child:focus::before,\n[dir=\"rtl\"] .button-group .button:first-child:focus::before {\n    border-radius: 0 calc(0.5rem / 2) calc(0.5rem / 2) 0;\n}\n\n.button:disabled > img {\n    opacity: 0.25;\n}\n\n.info-row {\n    display: flex;\n    justify-content: space-between;\n    margin-top: calc(2 * 0.5rem);\n}\n\n.duration {\n    font-weight: bold;\n}\n\n.advanced-info {\n\n}\n\n.alert {\n    margin-top: calc(2 * 0.5rem);\n    border-radius: 5px;\n    padding: 0.5rem;\n    display: flex;\n    align-items: center;\n    border-width: 1px;\n    border-style: solid;\n}\n\n.stereo {\n    background-color: rgba(145, 145, 255, 0.3);\n    border-color: rgb(145, 145, 255)\n}\n\n.too-large {\n    background-color: rgba(255, 119, 0, 0.3);\n    border-color: rgb(255, 119, 0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor-container": `sound-editor_editor-container_u4gVN`,
	"editorContainer": `sound-editor_editor-container_u4gVN`,
	"row": `sound-editor_row_etYpe`,
	"row-reverse": `sound-editor_row-reverse_gT1kt`,
	"rowReverse": `sound-editor_row-reverse_gT1kt`,
	"input-group": `sound-editor_input-group_CbHjS`,
	"inputGroup": `sound-editor_input-group_CbHjS`,
	"name-input": `sound-editor_name-input_SnE1i`,
	"nameInput": `sound-editor_name-input_SnE1i`,
	"waveform-container": `sound-editor_waveform-container_Q15Oq`,
	"waveformContainer": `sound-editor_waveform-container_Q15Oq`,
	"button": `sound-editor_button_JdvOv`,
	"round-button-outer": `sound-editor_round-button-outer_J4Uag`,
	"roundButtonOuter": `sound-editor_round-button-outer_J4Uag`,
	"round-button": `sound-editor_round-button_Z7v_a`,
	"roundButton": `sound-editor_round-button_Z7v_a`,
	"undo-icon": `sound-editor_undo-icon_qzwjn`,
	"undoIcon": `sound-editor_undo-icon_qzwjn`,
	"redo-icon": `sound-editor_redo-icon_yNaBF`,
	"redoIcon": `sound-editor_redo-icon_yNaBF`,
	"trim-button": `sound-editor_trim-button_cBeZK`,
	"trimButton": `sound-editor_trim-button_cBeZK`,
	"effects": `sound-editor_effects_XD2c5`,
	"effect-button": `sound-editor_effect-button_NchAD`,
	"effectButton": `sound-editor_effect-button_NchAD`,
	"tool-button": `sound-editor_tool-button_Skubj`,
	"toolButton": `sound-editor_tool-button_Skubj`,
	"flip-in-rtl": `sound-editor_flip-in-rtl_WMq6B`,
	"flipInRtl": `sound-editor_flip-in-rtl_WMq6B`,
	"button-group": `sound-editor_button-group_VRpfa`,
	"buttonGroup": `sound-editor_button-group_VRpfa`,
	"info-row": `sound-editor_info-row_rkZGZ`,
	"infoRow": `sound-editor_info-row_rkZGZ`,
	"duration": `sound-editor_duration_nrOCf`,
	"advanced-info": `sound-editor_advanced-info_neXoT`,
	"advancedInfo": `sound-editor_advanced-info_neXoT`,
	"alert": `sound-editor_alert_XHz2j`,
	"stereo": `sound-editor_stereo_UyJne`,
	"too-large": `sound-editor_too-large_wNGOY`,
	"tooLarge": `sound-editor_too-large_wNGOY`
};
export default ___CSS_LOADER_EXPORT___;
